import axios from 'axios'
import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { IgetSnapshot, Irequest } from '../types/index'

// worker Saga: will be fired on POST_SNAPSHOT actions
function createRequest(request: Irequest) {
  return axios({
    method: request.method,
    url: request.url,
  })
}

/**
 * Starts createRequest on each dispatched 'POST_SNAPSHOT' action
 * Allows concurrent requests
 */
function* callApi(action: IgetSnapshot) {
  yield put({ type: `${action.type}_REQUEST` })
  try {
    const result = yield call(createRequest, action.payload.request)
    yield put({
      type: `${action.type}_SUCCESS`,
      payload: {
        view: action.payload.view,
        snapshot: result.data.snapshot
      },
      contentType: result.headers['content-type'].toLowerCase(),
    })
  } catch (err) {
    yield put({ type: `${action.type}_FAIL`, payload: err.response.data })
  }
}

function* handleRequest() {
  yield takeEvery('POST_SNAPSHOT', callApi)
}

export default function* root() {
  yield all([
    fork(handleRequest)
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/apiCallSaga.ts